module.exports = __webpack_public_path__ + "img/yeled_haham_yes.c4e89944.png";